import React, { useEffect, useState } from 'react'
import { Form, Button, notification, Drawer, Input, Col, Row } from 'antd'
import { useDispatch } from 'react-redux'
import { listAllCountries } from '../../countries/actions/countries'
import { listQuickSearchUniversities } from '../../university/actions/university'
import { addPendingUniversityContractFxn } from '../actions/contract'
import moment from 'moment'
import GetEachFormFields from '../../../components/_utils/appFormUtils'

const AddPendingUniversityContract = (props) => {
  const { form: { getFieldDecorator, setFieldsValue, getFieldValue }, visible, events, universityTypeList } = props
  const dispatch = useDispatch()
  let [allCountry, setAllCountry] = useState([])
  let [countryUniversity, setCountryUniversity] = useState([])
  let [mediaKey, setMediaKey] = useState(moment())

  const appEvents = {
    loadCountry: async () => {
      let filters = {
        sortField: 'countryName', sortOrder: 'ascend',
        results: 100,
        count: 100,
        active: [false, true]
      }
      let { data } = await dispatch(listAllCountries(filters))
      setAllCountry(data)
    },
    loadUniversity: async (item) => {
      let obj = {
        results: 1000000,
        universityCountry: item,
        sortField: 'universityName',
        sortOrder: 'ascend'
      }
      let data = await dispatch(listQuickSearchUniversities(obj))
      setCountryUniversity(data)
    }
  }

  useEffect(() => {
    appEvents.loadCountry()
  }, [])


  let inputTypes = {
    fields: [
      {
        key: 'countryId',
        label: 'Country',
        required: true,
        type: 'select',
        showSearch: true,
        options: allCountry,
        keyAccessor: x => x._id,
        valueAccessor: x => `${x.countryName}`,
        onChange: x => {
          setFieldsValue({
            countryId: x,
            universityId: undefined
          })
          appEvents.loadUniversity(x)
        }
      },
      {
        key: 'universityType',
        label: 'University Type',
        required: true,
        type: 'select',
        showSearch: true,
        options: universityTypeList,
        keyAccessor: x => x.value,
        valueAccessor: x => `${x.name}`,
        onChange: x => {
          setFieldsValue({
            universityType: x,
            universityId: undefined,
            universityName: undefined
          })
        }
      },
      {
        key: 'universityId',
        label: 'University',
        required: true,
        type: 'select',
        hidden: !(getFieldValue('universityType') && getFieldValue('universityType') == 'alreadyAdded'),
        showSearch: true,
        options: countryUniversity,
        keyAccessor: x => x._id,
        valueAccessor: x => `${x.universityName}`,
        onChange: x => {
          setFieldsValue({
            universityId: x
          })
        }
      },
      {
        key: 'universityName',
        label: 'University',
        required: true,
        placeholder: 'University',
        hidden: !(getFieldValue('universityType') && getFieldValue('universityType') == 'other')
      },
      {
        key: 'universityCity',
        label: 'Campus City',
        placeholder: 'Campus City'
      },
      {
        key: 'expectedDate',
        label: 'Expected Date',
        placeholder: 'Expected Date',
        type: 'date'
      },
      {
        key: 'details',
        label: 'Details',
        placeholder: 'Details',
        type: 'textarea',
        span: 24
      }
    ]
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 0 },
      sm: { span: 0 },
      md: { span: 0 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 }
    }
  }

  const handleSubmit = e => {
    const { form } = props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let data = await dispatch(addPendingUniversityContractFxn(valData))
        if (data && data.success) {
          form.resetFields()
          setMediaKey(moment())
          events.hidePendingUniDrawer()
        }
      } else {
        notification.warning({
          message: 'Fill All Required Fields'
        })
      }
    })
  }


  return (
    <Drawer
      visible={visible}
      width={'45%'}
      placement='right'
      onClose={events.hidePendingUniDrawer}
      title={'Add Pending University Contract'}>
      <div className='form-box'>
        <div className='card unizportal'>
          <Form onSubmit={handleSubmit}>
            <Row gutter={16} className={'wrapBox'}>
              {inputTypes.fields.map((item, key) => {
                return (
                  <React.Fragment key={key}>
                    {item.customField ?
                      <Col span={item.span ? item.span : 12}>
                        {item.customField}
                      </Col>
                      :
                      !item.hidden && <Col span={item.span ? item.span : 12} key={key}>
                        <GetEachFormFields
                          item={item}
                          getFieldDecorator={getFieldDecorator}
                          formItemLayout={formItemLayout} />
                      </Col>}
                  </React.Fragment>
                )
              })}
            </Row>
            <Form.Item style={{ marginTop: 25 }}>
              <Button type='primary' htmlType='submit' className={'btn'}>
                ADD
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </Drawer>
  )
}
const WrappedCountry = Form.create()(AddPendingUniversityContract)
export default WrappedCountry
